<div mat-dialog-title class="dialog-title p-3 pr-5">
  <h5>Step Hazard/Risk</h5>
  <button
    mat-icon-button
    aria-label="Close dialog"
    matTooltip="Close this dialog."
    mat-dialog-close
    class="dialog-close-button">
    <mat-icon>close</mat-icon>
  </button>
</div>

<hr class="m-0 p-0">

<mat-dialog-content class="px-3 py-4">

  <form #f="ngForm" (ngSubmit)="onSubmitHazard(f)">

    <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
      <mat-label>Hazard/Risk</mat-label>
      <input
        matInput
        placeholder="Hazard/Risk"
        [(ngModel)]="ta_revised_workflow_hazard.name"
        name="name"
        type="text"
        #name
        required />
      <mat-error *ngIf="!name.valid">Please enter the Hazard/Risk name. </mat-error>
    </mat-form-field>

    <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
      <mat-label>Description</mat-label>
      <textarea
        rows="7"
        matInput
        placeholder="Description"
        [(ngModel)]="ta_revised_workflow_hazard.description"
        name="description"
        #description
        required>
      </textarea>
      <mat-error *ngIf="!description.valid">Please enter a description for this Hazard/Risk.</mat-error>
    </mat-form-field>

    <mat-checkbox [(ngModel)]="ta_revised_workflow_hazard.significant" name="significant" class="full-width mb-4">
      Significant Hazard/Risk (please tick the box if this is a significant hazard/risk).
    </mat-checkbox>

    <div class="row m-0">
      <div class="col-lg-6 p-0 pr-lg-3">
        <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
          <mat-label>Status</mat-label>
          <mat-select
            placeholder="Status"
            [(ngModel)]="ta_revised_workflow_hazard.status"
            name="status"
            required
            id="status">
            <mat-option value="Unverified">Unverified</mat-option>
            <mat-option value="Verified">Verified</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col-lg-6 p-0 pl-lg-3">
        <app-datetime-picker
          *ngIf="ta_revised_workflow_hazard?.id"
          [selectedDateTime]="reviewedAtDateTime"
          [pickerName]="'reviewedAtDateTime'"
          [label]="'Select the upcoming review date.'"
          [hint]="'Use the calendar icon to select the date and time.'"
          [selectTooltip]="'Select the date and time.'"
          [removeTooltip]="'Clear the date and time.'"
          [classes]="'full-width mb-4'"
          (pickerDetailsOutput)="getOutputDateTimeDetails($event)">
        </app-datetime-picker>
      </div>
    </div>

    <div class="m-0 mb-4">
      <h5 class="card-title mr-2">Initial Risk Assessment</h5>
      <button
        type="button"
        mat-raised-button
        color="secondary"
        class="m-1 mr-2"
        (click)="onViewMatrix('Initial')"
        matTooltip="View/Update Initial Risk Matrix">
        <mat-icon>assessment</mat-icon>
        Initial Risk Matrix
      </button>
    </div>

    <div class="row m-0">
      <div class="col-lg-6 p-0 pr-lg-3">
        <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
          <mat-label>Likelihood</mat-label>
          <input
            matInput
            placeholder="Likelihood"
            readonly
            required
            [value]="utils.getRiskAssessmentLikelihoodList()[ta_revised_workflow_hazard.ira_likelihood - 1]"
            name="ira_likelihood"
            type="text"
            #ira_likelihood />
        </mat-form-field>
      </div>
      <div class="col-lg-6 p-0 pl-lg-3">
        <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
          <mat-label>{{ utils.getLangTerm('hazards.form.severity', 'Severity') }}</mat-label>
          <input
            matInput
            [placeholder]="utils.getLangTerm('hazards.form.severity', 'Severity')"
            readonly
            required
            [value]="utils.getRiskAssessmentSeverityList()[ta_revised_workflow_hazard.ira_severity - 1]"
            name="ira_severity"
            type="text"
            #ira_severity />
        </mat-form-field>
      </div>
    </div>

    <div
      class="mb-4 alert alert-{{ getRiskAssessmentColorChange(ta_revised_workflow_hazard.ira_likelihood, ta_revised_workflow_hazard.ira_severity) }}"
      role="alert">{{ utils.getRiskAssessmentText(ta_revised_workflow_hazard.ira_likelihood, ta_revised_workflow_hazard.ira_severity) }}
    </div>

    <div class="m-0 mb-4">
      <h5 class="card-title mr-2">Hazard/Risk Controls</h5>
      <button
        type="button"
        mat-raised-button
        color="secondary"
        class="m-1 mr-2"
        (click)="onAddControl()"
        matTooltip="Add Hazard/Risk Control">
        <mat-icon>add</mat-icon>
        Add Control
      </button>
      <button
        type="button"
        mat-raised-button
        color="secondary"
        class="m-1 mr-2"
        (click)="onViewHierarchyOfControl()"
        matTooltip="View Hierarchy of Controls">
        <mat-icon>vertical_align_bottom</mat-icon>
        Hierarchy of Controls
      </button>
    </div>

    <div *ngFor="let control of ta_revised_workflow_hazard.controls; let i = index">
      <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
        <mat-label>Control {{ i + 1 }}</mat-label>
        <input
          matInput
          placeholder="Control {{ i + 1 }}"
          [(ngModel)]="ta_revised_workflow_hazard.controls[i].control"
          [ngModelOptions]="{ standalone: true }"
          type="text"
          required />
        <mat-error *ngIf="!ta_revised_workflow_hazard.controls[i].control">Please enter a control.</mat-error>
      </mat-form-field>

      <div class="row mb-4">
        <div class="col-9">
          <mat-form-field class="full-width" appearance="outline" subscriptSizing="dynamic">
            <mat-label>Level of Control</mat-label>
            <mat-select
              placeholder="Level of Control"
              [(ngModel)]="ta_revised_workflow_hazard.controls[i].loc"
              [ngModelOptions]="{ standalone: true }"
              required>
              <mat-option
                *ngFor="let loc of loc_list; let i = index"
                [value]="i + 1">
                {{ loc }}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="!ta_revised_workflow_hazard.controls[i].loc">Please select a level of control.</mat-error>
          </mat-form-field>
        </div>

        <div class="col-3">
          <button
            type="button"
            mat-icon-button
            color="warn"
            class="dialog-remove-button my-2 ml-1 mr-0"
            (click)="onRemoveControl(i)"
            *ngIf="ta_revised_workflow_hazard.controls.length > 1"
            matTooltip="Delete this Hazard/Risk Control">
            <mat-icon>delete</mat-icon>
          </button>
        </div>
      </div>
    </div>

    <div class="m-0 mb-4">
      <h5 class="card-title mr-2">Residual Risk Assessment</h5>
      <button
        type="button"
        mat-raised-button
        color="secondary"
        class="m-1 mr-2"
        (click)="onViewMatrix('Residual')"
        matTooltip="View/Update Residual Risk Matrix">
        <mat-icon>assessment</mat-icon>
        Residual Risk Matrix
      </button>
    </div>


    <div class="row m-0">
      <div class="col-lg-6 p-0 pr-lg-3">
        <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
          <mat-label>Likelihood</mat-label>
          <input
            matInput
            placeholder="Likelihood"
            readonly
            required
            [value]="utils.getRiskAssessmentLikelihoodList()[ta_revised_workflow_hazard.rra_likelihood - 1]"
            name="rra_likelihood"
            type="text"
            #rra_likelihood />
        </mat-form-field>
      </div>
      <div class="col-lg-6 p-0 pl-lg-3">
        <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
          <mat-label>{{ utils.getLangTerm('hazards.form.severity', 'Severity') }}</mat-label>
          <input
            matInput
            [placeholder]="utils.getLangTerm('hazards.form.severity', 'Severity')"
            readonly
            required
            [value]="utils.getRiskAssessmentSeverityList()[ta_revised_workflow_hazard.rra_severity - 1]"
            name="rra_severity"
            type="text"
            #rra_severity />
        </mat-form-field>
      </div>
    </div>

    <div
      class="mb-0 alert alert-{{ getRiskAssessmentColorChange(ta_revised_workflow_hazard.rra_likelihood, ta_revised_workflow_hazard.rra_severity) }}"
      role="alert">
      {{ utils.getRiskAssessmentText(ta_revised_workflow_hazard.rra_likelihood, ta_revised_workflow_hazard.rra_severity) }}
    </div>

  </form>

</mat-dialog-content>

<hr class="m-0 p-0">

<mat-dialog-actions class="p-3">
  <button
    type="button"
    mat-raised-button
    [disabled]="!f.valid || inProgress || !hasValidControls() || !ta_revised_workflow_hazard.id"
    color="primary"
    class="my-2 ml-1 mr-2"
    (click)="onSubmitHazard(f, false)"
    id="save">
    <mat-icon>save</mat-icon>
    Save
  </button>

  <button
    type="button"
    mat-raised-button
    [disabled]="!f.valid || inProgress || !hasValidControls()"
    color="primary"
    class="my-2 ml-1 mr-2"
    (click)="onSubmitHazard(f)"
    id="save_close">
    <mat-icon>save</mat-icon>
    Save & Close
  </button>

  <app-file-browse-button
    (selectedFiles)="onSelectFiles(f, $event)"
    (afterDialogClosedEvent)="onSubmitHazard(f, false, true)"
    (afterFileRemove)="onRemoveFile($event)"
    parentObjectType="task_analysis_revised_step_hazard"
    [parentObjectId]="ta_revised_workflow_hazard.id"
    [parentRemove]="false"
    [parentUpload]="false"
    [filesCount]="ta_revised_workflow_hazard.files?.length">
  </app-file-browse-button>

  <button
    type="button"
    mat-raised-button
    color="secondary"
    class="my-2 ml-1 mr-2"
    [disabled]="inProgress"
    (click)="onSelectReviewer()"
    [matBadge]="'' + (ta_revised_workflow_hazard.reviewer_id ? 1 : 0)"
    *ngIf="ta_revised_workflow_hazard?.id"
    matTooltip="You can optionally select a reviewer.">
    <mat-icon>rate_review</mat-icon>
    {{ !ta_revised_workflow_hazard.reviewer_id ? 'Select' : 'Change' }} Reviewer
  </button>

  <button
    type="button"
    mat-raised-button
    color="secondary"
    class="my-2 ml-1 mr-2"
    [disabled]="inProgress"
    (click)="onRestoreFromRef()"
    *ngIf="ta_revised_workflow_hazard?.reference_id"
    matTooltip="Overwrite all Hazard data with the {{ utils.getLangTerm('parent-child-sites-combined.singular', 'Site') }} Hazard/Risk used to create it.">
    <mat-icon>restore</mat-icon>
    Restore from Reference #{{ ta_revised_workflow_hazard.reference_id }}
  </button>

  <button
    type="button"
    mat-icon-button
    [disabled]="!ta_revised_workflow_hazard?.id"
    color="warn"
    class="dialog-remove-button my-2 ml-auto mr-1"
    (click)="onDelete()"
    matTooltip="Remove this Hazard/Risk">
    <mat-icon>delete</mat-icon>
  </button>
</mat-dialog-actions>

